import {useEffect, useMemo, useState} from "react";
import {useDispatch} from "react-redux";
import {clearSelectedEpisode, clearSelectedSeason, fetchMovie} from "../actions";
import auth from "../../../utils/authentication";
import useViewTMDBContent from "./useViewTMDBContent";
import {fetchTmdbMovieImages} from "../api/cap17drive-api";
import {SquadflixSocketEmitEvents} from "../../app/squadflix-tv-mode/socket-utils/socket-send-events";
import {SquadflixNavigationRecord} from "../squadflixHome/useSquadflixNavigate";

export const pickBestTmdbImages = (res: any) => {
    let selectedLogo = null;
    if (res?.logos?.length) {
        selectedLogo =
            res.logos.find((logo: any) => logo.iso_639_1 === "es") ||
            res.logos.find((logo: any) => logo.iso_639_1 === "en") ||
            res.logos[0];
    }

    let selectedBackdrop = null;
    if (res?.backdrops?.length) {
        let maxWidth = Number.MIN_SAFE_INTEGER;
        res.backdrops
            .filter((x: any) => x.iso_639_1 == null)
            .sort((a: any, b: any) => b.vote_average - a.vote_average)
            .forEach((backdropCandidate: any) => {
                if (backdropCandidate.width > maxWidth) {
                    selectedBackdrop = backdropCandidate;
                    maxWidth = backdropCandidate.width;
                }
            });
        if (!selectedBackdrop) {
            selectedBackdrop = res.backdrops[0];
        }
    }

    return {selectedLogo, selectedBackdrop};
};

export const useMovieDetailsData = (id: string, squadflixTvHook?: any) => {
    const dispatch = useDispatch();
    const [from] = useState(() => SquadflixNavigationRecord.getLastEntry());
    const {thing: movie, markThingAsView} = useViewTMDBContent();
    const [logoImage, setLogoImage] = useState<any>(null);
    const [backgroundImage, setBackgroundImage] = useState<any>(null);

    useEffect(() => {
        if (!id || !auth.currentUser) return;
        dispatch(clearSelectedEpisode() as any);
        dispatch(clearSelectedSeason() as any);
        dispatch(fetchMovie(id, auth.currentUser.uid) as any);
    }, [dispatch, id]);

    useEffect(() => {
        if (!id) return;
        setLogoImage(null);
        setBackgroundImage(null);
        fetchTmdbMovieImages(id).then(res => {
            const {selectedLogo, selectedBackdrop} = pickBestTmdbImages(res);
            setLogoImage(selectedLogo);
            setBackgroundImage(selectedBackdrop);
        }).catch(() => {});
    }, [id]);

    useEffect(() => {
        if (!squadflixTvHook?.connectedReceptor || !movie) return;
        SquadflixSocketEmitEvents.sendViewingItem(squadflixTvHook.connectedReceptor, movie, "movie");
    }, [movie, squadflixTvHook?.connectedReceptor]);

    const backgroundAspectRatio = useMemo(() => {
        return backgroundImage ? (backgroundImage.height / backgroundImage.width) : (9 / 16);
    }, [backgroundImage]);

    return {
        movie,
        markThingAsView,
        logoImage,
        backgroundImage,
        backgroundAspectRatio,
        from,
    };
};

export default useMovieDetailsData;
